
export default [
    {
      path: '/collectMoney/cardRecord',
      component: resolve => require(['../page.vue'], resolve),
      meta: {
          title: '转卡记录',
          keepAlive: false
      }
    },   
];
  